import React from 'react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  return <section id="pricing" className="py-8 sm:py-12 px-4 bg-brand-cream scroll-mt-10" data-id="element-103">
      <div className="max-w-2xl mx-auto" data-id="element-104">
        <div className="bg-white border-4 border-brand-gold rounded-xl p-8 text-center relative" data-id="element-105">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-white font-bold px-6 py-2 rounded-full text-sm uppercase tracking-wide" data-id="element-106">
            COMPLETE 6-IN-1 SYSTEM
          </div>

          <div className="mt-4 mb-6" data-id="element-107">
            <p className="text-lg text-brand-text-muted mb-2" data-id="element-108">
              Total System Value: <span className="line-through" data-id="element-109">$227 USD</span>
            </p>
            <p className="text-6xl font-serif font-bold text-brand-forest mb-2" data-id="element-110">
              $27 USD
            </p>
            <p className="text-sm text-brand-text-muted" data-id="element-111">
              One-Time Payment. No Subscriptions. Instant Access.
            </p>
          </div>

          <CTAButton href="https://thyroidreset.impultienda.ar/checkout" data-id="element-112">
            YES! I WANT INSTANT ACCESS
          </CTAButton>
        </div>
      </div>
    </section>;
}